import styled from 'styled-components';

import { body } from '@constants/fonts';

export const Date = styled.div<{ today?: boolean; right?: boolean }>`
  display: block;
  width: max-content;
  padding: 0 10px;
  box-sizing: border-box;
  min-height: 27px;
  color: ${({ theme }) => theme.palette.secondary.main};
  background-color: ${({ theme }) => theme.palette.error.light};
  text-align: center;
  vertical-align: middle;
  line-height: 27px;
  font-size: 13px;
  font-weight: 700;
  position: absolute;
  top: 0;
  ${(props) => (props.right ? 'right: -3px' : 'left: 0')};
  border-top-${(props) => (props.right ? 'right' : 'left')}-radius: 7px;
  border-bottom-${(props) => (props.right ? 'left' : 'right')}-radius: 1px;
`;

export const InfoTextBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 10px 0 0 0;
`;

export const OuterContainer = styled.div<{
  clickable: boolean;
  color: string;
  paddingTop?: number;
}>`
  position: relative;
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: ${({ theme }) => theme.shadows[24]};
  font-family: ${body};
  font-weight: lighter;
  text-align: left;

  border: none;
  border-right: 3px solid ${(props) => props.color};

  padding: ${(props) => props.paddingTop ?? 15}px 20px 15px 30px;
  margin: 0 0 15px 0;
  cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};

  transition:
    box-shadow 0.1s,
    transform 0.3s ease-in-out;

  &:hover {
    ${(props) =>
      props.clickable
        ? `box-shadow: ${props.theme.shadows[24]}; transform: scale(1.01);`
        : ''}
  }
`;

export const InnerContainer = styled.div`
  width: 100%;
  position: relative;
  background-color: ${({ theme }) => theme.palette.background.paper};

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  margin: 0 0 15px 0;
`;

export const StatusContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.info.main};
  width: 6px;
  height: 6px;

  border-radius: 50%;
  position: absolute;
  top: -24px;
  left: -18px;
`;
